module.exports = __webpack_public_path__ + "img/ai-logo.6b58dcb0.png";